<template>
    <div class="table-of-content grid grid__dot-cols" v-bind="cmsEditHelperAttrs">
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <ul class="grid--row table-of-content--items u-reset">
            <li class="grid--col table-of-content--item" v-for="(page, pageIdx) in content.table_of_contents">
                <div class="table-of-content--link-wrap">
                    <router-link class="u-reset table-of-content--link" :class="bemAdd(page.theme || 'neutral', 'link')"
                            :to="page.path">
                        <div class="table-of-content--link-row">
                            <div class="table-of-content--link-arrow-col table-of-content--link-arrow-col__placeholder"></div>
                            <div class="table-of-content--link-col">
                                <div class="table-of-content--link-content">
                                    <h2 class="u-reset u-reset__h1 table-of-content--title" v-html="page.title"></h2>
                                    <p class="table-of-content--lead" v-if="page.lead" v-text="page.lead"></p>
                                </div>
                            </div>
                            <div class="table-of-content--link-arrow-col">
                                <div class="table-of-content--link-arrow">
                                    <div class="table-of-content--link-bg"></div>
                                    <cmp-icon class="table-of-content--link-icon table-of-content--link-icon__big"
                                            symbol="chevron_big" size="large">
                                    </cmp-icon>
                                    <cmp-icon class="table-of-content--link-icon table-of-content--link-icon__small"
                                            symbol="chevron_right" size="x-small">
                                    </cmp-icon>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';
    import bemMixin from 'vue/mixins/bem';


    export default {
        mixins: [
            bemMixin('table-of-content'),
            cmsPlugin,
        ],
    };
</script>



// WEBPACK FOOTER //
// index.vue?232616a6